import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { makeStyles } from "@material-ui/styles"
import { Hidden, ClickAwayListener } from "@material-ui/core"

import { Navbar, MobileNavbar, CartModal, AddedToCartBanner,LocationAlertBanner } from ".."

const useStyles = makeStyles(theme => ({
  root: {
    top: 0,
    position: "sticky",
    zIndex: 3,
  },
  box: {
    height: theme.spacing(2.5),
    width: "100%",
    backgroundColor: "white",
  },
}))

export default injectIntl(props => {
  const [open, setOpen] = useState(true)
  const [cartOpen, setCartOpen] = useState(false)
  const [mainMenuValue, mainMenuSetValue] = useState()
  const { intl } = props

  function handleChange(event, newValue) {
    mainMenuSetValue(newValue)
    setOpen(true)
  }

  const handleClickAway = () => {
    setOpen(!open)
    mainMenuSetValue(null)
  }
  const handleCart = () => {
    setCartOpen(!cartOpen)
  }
  // Items of the menu (menuItems object)

  const i18nmessages = intl.messages
  const menuItems = i18nmessages.headerItems

  const classes = useStyles()
  return (
    <div className={classes.root}>
        <LocationAlertBanner />

      <CartModal
        open={cartOpen}
        onClose={handleCart}
        isModal={true}
        langKey={intl.locale}
        header={props.data}
      />
      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <Hidden mdDown>
            <Navbar
              mainMenu="true"
              items={Object.keys(menuItems)}
              values={mainMenuValue}
              onChange={handleChange}
              cartToggle={handleCart}
              slug={props.slug}
              response={props.response}
              locale={intl.locale}
              data={props.data}
            />
          </Hidden>

          <div>
            {open ? (
              <div>
                <Hidden mdDown>
                  {Object.keys(menuItems).map(
                    (menuItem, index) =>
                      mainMenuValue === index &&
                      menuItem !== "store locator" &&
                      menuItem !== "localizador de tiendas" && (
                        <Navbar
                          category={menuItem}
                          key={index}
                          items={menuItems[menuItem]}
                          slug={props.slug}
                          response={props.response}
                          data={props.data}
                        ></Navbar>
                      )
                  )}
                </Hidden>
              </div>
            ) : null}
          </div>
        </div>
      </ClickAwayListener>
      <Hidden lgUp>
        <MobileNavbar
          cartToggle={handleCart}
          items={menuItems}
          slug={props.slug}
          response={props.response}
          data={props.data}
        ></MobileNavbar>
      </Hidden>
      <AddedToCartBanner copyText={i18nmessages.hasBeenAddedToCart} />
    </div>
  )
})
